module.exports = __webpack_public_path__ + "static/img/xian.7563768.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/city/xian.jpg
// module id = jOvj
// module chunks = 1